/* eslint radix: ["error", "as-needed"] */
/* eslint-disable no-unexpected-multiline */

// UI 
import React, { Component } from 'react';
import { render } from 'react-dom';

// State
import createStore  from 'redux-zero';
import { bindActions } from 'redux-zero/utils'
// import { Provider, connect } from "redux-zero/react"

// Components
import Snake, { getGamePlayActions, initialState, direction } from './Snake';
import { ShowScore, PlayerName , saveScoreActions, scoreboardActions, setLongestTailSubscription } from './Score'

// Helpers
import { always } from './functional';

// import {generateId} from './generateId'

// Data
import firebase from '@firebase/app'
import '@firebase/database'


// Styles
import './style.css';


// localStorage.setItem('longestTail',0)


// Initialize Firebase
var config = {
  apiKey: "AIzaSyDJdz95rOkLa3F9JF79edMIUEL7JU_EJ2o",
  authDomain: "react-snake-game.firebaseapp.com",
  databaseURL: "https://react-snake-game.firebaseio.com",
  projectId: "react-snake-game",
  storageBucket: "",
  messagingSenderId: "564947477278"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config)
} 

const firebaseDb = firebase.database()
window.fire = firebaseDb
const firebaseScoreboard = firebaseDb.ref('scoreboard')
// debugger
// console.log('init',initialState)

const store = createStore({
  ...initialState,
  longestTail: parseInt(localStorage.getItem('longestTail')) || 0,
  username: localStorage.getItem('username')
})

const time = () => ({time: Date.now()})



store.subscribe(setLongestTailSubscription(firebaseDb)(firebaseScoreboard)(store))

const defaultMotionActions = () => ({
  ...time(),
  pause: false,
})


// Example extending game features by modifying state actions from outside of component
const eventActions = {
  ArrowLeft: ({directionText}) => directionText !== 'R' ? ({
    ...direction.left,
    ...defaultMotionActions(), 
    directionText: 'L',
  }) : ({}),
  ArrowRight: ({directionText}) => directionText !== 'L' ? ({
    ...direction.right,
    ...defaultMotionActions(),
    directionText: 'R',
  }) : ({}),
  ArrowDown: ({directionText}) => directionText !== 'D' ? ({
    ...direction.down,
    ...defaultMotionActions(), 
    directionText: 'U', 
  }) : ({}),
  ArrowUp: ({directionText}) => directionText !== 'U' ? ({
    ...direction.up,
    ...defaultMotionActions(), 
    directionText: 'D',
  }) : ({}),
}


const actions = store => ({
  ...eventActions,
  ...getGamePlayActions(store),
  ...scoreboardActions(firebaseDb)(firebaseScoreboard)(store),
  ...saveScoreActions(store),
});


// Bind actions to store 
const boundActions = bindActions(actions,store)
// console.log(scoreboardActions(firebaseDb)(store))
// Bind keyboard events to bound actions
const keypush = event => {
  if(event.key.length === 1 || event.keyCode === 8) {
    return
  }
  event.preventDefault()
  event.stopPropagation()
  return (boundActions[event.key] || always)();
}
document.addEventListener('keydown',keypush)


// Connect state to component props
// const mapToProps = identity

class App extends Component {
  componentDidMount(){
    this.frameAdvance = this.refs.snake.frameAdvance.bind(this.refs.snake)
    this.loopInterval = this.startSnakeLoop()
    store.subscribe( () => this.forceUpdate())
    boundActions.loadScoreboard(store.getState())
  }

  startSnakeLoop(){
    try {
      return setInterval(this.frameAdvance,initialState.baseSpeed)
    } catch(e){
      console.log(e)
    }

  }
  render(){
    return (
      <div id="game-area">
        <PlayerName {...boundActions} {...store.getState()} store={store} />
        <Snake 
          ref="snake" {...boundActions} 
          {...store.getState()} store={store}/>
        <ShowScore {...boundActions}  {... store.getState() } store={store} />
      </div>
    )
  }
}

render(<App />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js